module.exports = __webpack_public_path__ + "img/mobilephone2.48bcd053.png";